import React from "react";
import { useParams, Link } from "react-router-dom";
import styles from "./NewsDetailPage.module.css";
import { newsItems } from "../data/newsItems";

export default function NewsDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const item = newsItems.find((n) => n.slug === slug);

  if (!item) {
    return (
      <section className={styles.page}>
        <div className={styles.inner}>
          <p className={styles.backWrap}>
            <Link to="/aktuelles" className={styles.backLink}>
              ← Zurück zu Aktuelles
            </Link>
          </p>
          <h1 className={styles.title}>Beitrag nicht gefunden</h1>
          <p className={styles.lead}>
            Der gesuchte Beitrag steht nicht mehr zur Verfügung oder wurde verschoben.
          </p>
        </div>
      </section>
    );
  }

  const isPortrait = (src: string) => /-vert(\.|-)/i.test(src);


  const topPortraits =
    (item.gallery || []).length === 2 && (item.gallery || []).every(isPortrait)
      ? (item.gallery || [])
      : null;


  const heroJpg = item.image;
  const heroBase = heroJpg.replace(/\.jpg$/i, "");
  const heroAvif = `${heroBase}.avif`;
  const heroWebp = `${heroBase}.webp`;

  return (
    <article className={styles.page}>
      <div className={styles.inner}>
        <p className={styles.backWrap}>
          <Link to="/aktuelles" className={styles.backLink}>
            ← Aktuelles &amp; Presse
          </Link>
        </p>


        {topPortraits ? (
          <div className={styles.heroPortraitGrid} aria-label="Bilder">
            {topPortraits.map((src, idx) => {
              const base = src.replace(/\.jpg$/i, "");
              const avif = `${base}.avif`;
              const webp = `${base}.webp`;

              return (
                <div key={src} className={styles.heroPortraitTile}>
                  <picture>
                    <source srcSet={avif} type="image/avif" />
                    <source srcSet={webp} type="image/webp" />
                    <img
                      src={src}
                      alt={`${item.title} – Foto ${idx + 1}`}
                      loading="eager"
                      decoding="async"
                      className={styles.heroPortraitImg}
                    />
                  </picture>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.heroImageWrap}>
            <picture>
              <source srcSet={heroAvif} type="image/avif" />
              <source srcSet={heroWebp} type="image/webp" />
              <img src={heroJpg} alt={item.title} loading="eager" decoding="async" />
            </picture>
          </div>
        )}


        <header className={styles.header}>
          <div className={styles.metaRow}>
            <time className={styles.date}>{item.dateLabel || item.date}</time>
          </div>
          <h1 className={styles.title}>{item.title}</h1>
        </header>

   
        <section className={styles.body}>
          {item.body.map((p, idx) => (
            <p key={idx} className={styles.paragraph}>
              {p}
            </p>
          ))}
        </section>

        <p className={styles.backBottomWrap}>
          <Link to="/aktuelles" className={styles.backBottomLink}>
            ← Aktuelles &amp; Presse
          </Link>
        </p>
      </div>
    </article>
  );
}
